module.exports = __webpack_public_path__ + "static/docker-7bcbbab5e4c7c9a94f7a32016ae8f827.png";